import {
  Button,
  Col,
  Form,
  InputNumber,
  Row,
  Space,
  Table,
  message,
} from "antd";
import React, { FC, useEffect, useState } from "react";

import { Card, DisplayInput } from "@comps";
import { Http } from "@utils";

interface SplitNumProps {
  splitType: number;
  invId: number;
  checkIsCanSplit: (
    splitType: number,
    closeSplitAmountMD: () => void,
    splitNumbers: JSONObject[]
  ) => void;
  onClose: () => void;
  detail: JSONObject[];
}

const SplitNumMD: FC<SplitNumProps> = ({
  splitType,
  invId,
  checkIsCanSplit,
  onClose,
  detail,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  useEffect(() => {
    setLoading(true);
    if (detail?.length > 0) {
      form.setFieldsValue({
        splitNumDetail: detail,
      });
      setLoading(false);
    }
  }, [detail]);
  const columns: any[] = [
    {
      key: "lineNum",
      dataIndex: "lineNum",
      title: "序号",
      align: "center",
      width: 80,
      render: (text: any, field: any, index: any) => {
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "lineNum"]}
                fieldKey={[field.fieldKey, "lineNum"]}
                key={field.name}
              >
                <DisplayInput style={{ width: "100%", textAlign: "center" }} />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "invoiceGoodsName",
      dataIndex: "invoiceGoodsName",
      title: "货物或应税劳务、服务名称",
      align: "center",
      width: 300,
      render: (text: any, field: any, index: any) => {
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "invoiceGoodsName"]}
                fieldKey={[field.fieldKey, "invoiceGoodsName"]}
                key={field.name}
              >
                <DisplayInput style={{ width: "100%", textAlign: "center" }} />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "price",
      dataIndex: "price",
      title: "单价",
      align: "center",
      width: 150,
      render: (text: any, field: any, index: any) => {
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "price"]}
                fieldKey={[field.fieldKey, "price"]}
                key={field.name}
              >
                <DisplayInput style={{ width: "100%", textAlign: "center" }} />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "quantity",
      dataIndex: "quantity",
      title: "数量",
      align: "center",
      width: 100,
      render: (text: any, field: any, index: any) => {
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "quantity"]}
                fieldKey={[field.fieldKey, "quantity"]}
                key={field.name}
              >
                <DisplayInput style={{ width: "100%", textAlign: "center" }} />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "amount",
      dataIndex: "amount",
      title: "金额",
      align: "center",
      width: 150,
      render: (text: any, field: any, index: any) => {
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "amount"]}
                fieldKey={[field.fieldKey, "amount"]}
                key={field.name}
              >
                <DisplayInput style={{ width: "100%", textAlign: "center" }} />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "splitNum",
      dataIndex: "splitNum",
      title: "拆分数量",
      align: "center",
      width: 100,
      render: (text: any, field: any, index: any) => {
        const { splitNumDetail } = form.getFieldsValue();
        return (
          <Row gutter={8}>
            <Col span={22}>
              <Form.Item
                style={{ margin: 0 }}
                name={[field.name, "splitNum"]}
                fieldKey={[field.fieldKey, "splitNum"]}
                key={field.name}
              >
                <InputNumber
                  min={1}
                  style={{ width: "100%" }}
                  disabled={splitNumDetail[field.name]["discountLineFlag"]}
                />
              </Form.Item>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSelectChange = (selectedRowKey: React.Key[]) => {
    console.log("selected row keys: ", selectedRowKey);
    const { splitNumDetail } = form.getFieldsValue();
    let newSelectedRowKey: any[] = selectedRowKey;
    selectedRowKey.map((item, index) => {
      console.log(
        "item :>> ",
        splitNumDetail[item],
        splitNumDetail[item]["discountLineFlag"],
        !selectedRowKey.includes((item as number) - 1)
      );
      if (
        splitNumDetail[item]?.discountLineFlag &&
        !selectedRowKey.includes((item as number) - 1)
      ) {
        newSelectedRowKey.splice(index as number, 1);
      }
      if (splitNumDetail[item]["discountFlag"]) {
        newSelectedRowKey.push((item as number) + 1);
      }
    });

    console.log(
      "newSelectedRowKeys :>> ",
      newSelectedRowKey,
      Array.from(new Set(newSelectedRowKey))
    );

    setSelectedRowKeys(Array.from(new Set(newSelectedRowKey)));
  };
  const handleSubmit = () => {
    const { splitNumDetail } = form.getFieldsValue();
    if (selectedRowKeys.length === 0) {
      message.warning("请选择你要拆分的明细！");
    } else {
      let splitNumbers: JSONObject[] = [];
      //统计勾选项中折扣行及被折扣行的数量
      let discountLineFlagCount = 0; //折扣行
      let discountFlagCount = 0; //被折扣行
      selectedRowKeys.map((item, index) => {
        if (splitNumDetail[item]["discountFlag"]) {
          discountFlagCount++;
        }
        if (splitNumDetail[item]["discountLineFlag"]) {
          discountLineFlagCount++;
        }
      });
      let resultArr = selectedRowKeys.map((item, index) => {
        if (
          (splitNumDetail[item]["splitNum"] ?? "") !== "" &&
          splitNumDetail[item]["discountLineFlag"] === false
        ) {
          if (
            splitNumDetail[item]["splitNum"] > splitNumDetail[item]["quantity"]
          ) {
            message.warning(
              `序号:${(item as number) + 1}的明细，拆分数量大于实际数量！`
            );
            return false;
          } else {
            splitNumbers.push({
              quantity: splitNumDetail[item]["splitNum"],
              lineId: splitNumDetail[item]["id"],
            });
            return true;
          }
        } else if (splitNumDetail[item]["discountLineFlag"] === true) {
          //包含折扣行时
          if (discountFlagCount === discountLineFlagCount) {
            splitNumbers.push({
              quantity: splitNumDetail[item]["splitNum"],
              lineId: splitNumDetail[item]["id"],
            });
            return true;
          } else {
            message.warning(`折扣行不能单独选择，需跟着被折扣行一起选择`);
            return false;
          }
        } else {
          message.warning(
            `序号:${(item as number) + 1}的明细,请填写拆分条件！`
          );
          return false;
        }
      });
      resultArr.every((item) => item === true) &&
        checkIsCanSplit(splitType, onClose, splitNumbers);
    }
  };
  return (
    <Card title={`按数量拆分`}>
      <Form
        form={form}
        initialValues={{
          splitNumDetail: [],
        }}
        style={{ marginTop: 20, textAlign: "center" }}
        onFinish={() => handleSubmit()}
      >
        <Form.List name="splitNumDetail">
          {(fields, { add, remove }) => {
            return (
              <Table
                rowSelection={
                  columns.length
                    ? {
                        selectedRowKeys,
                        onChange: onSelectChange,
                        getCheckboxProps: (record: JSONObject) => {
                          const { splitNumDetail } = form.getFieldsValue();
                          return {
                            disabled:
                              splitNumDetail[record.name][
                                "discountLineFlag"
                              ] === true, // 配置无法勾选的列
                          };
                        },
                      }
                    : { hideSelectAll: true }
                }
                loading={loading}
                dataSource={fields}
                columns={columns}
                rowKey="key"
                pagination={false}
              />
            );
          }}
        </Form.List>
        <div style={{ marginTop: 12, paddingLeft: 20, textAlign: "center" }}>
          <Space size="large">
            <Button type="primary" htmlType="submit">
              拆分预览
            </Button>
            <Button onClick={onClose}>取消</Button>
          </Space>
        </div>
      </Form>
    </Card>
  );
};

export default SplitNumMD;
